import { UseMutationResult } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { createContext } from "react";

import { UpdateClientDescriptionsOrderRequest } from "@/types/request/UpdateClientDescriptionsOrderRequest";
import { UpdateDescriptionGroupsRequest } from "@/types/request/UpdateDescriptionGroupsRequest";
import { ErrorResponse } from "@/types/response/ErrorResponse";
import { GetDescriptionGroupsResponse } from "@/types/response/GetDescriptionGroupsResponse";
import { GetDescriptionsResponse } from "@/types/response/GetDescriptionsResponse";

export type DescriptionGroupContextType = {
    descriptionGroups: GetDescriptionGroupsResponse[] | undefined;
    descriptionGroupsError: ErrorResponse | null;
    descriptionGroupsLoading: boolean;
    descriptions: GetDescriptionsResponse[] | undefined;
    descriptionsError: ErrorResponse | null;
    descriptionsLoading: boolean;
    updateClientDescriptionsOrder: UseMutationResult<AxiosResponse, AxiosError<ErrorResponse>, UpdateClientDescriptionsOrderRequest>;
    updateClientDescriptionsOrderError?: ErrorResponse;
    updateClientDescriptionsOrderPending: boolean;
    saveDescriptionGroups: UseMutationResult<AxiosResponse, AxiosError<ErrorResponse>, UpdateDescriptionGroupsRequest>;
    saveDescriptionGroupsError?: ErrorResponse;
    saveDescriptionGroupsPending: boolean;
}

export const DescriptionGroupContext = createContext<DescriptionGroupContextType | undefined>(undefined);
